import { IStoreState } from "@montana/store/store";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { IDynamicSettingsContainerState } from "./dynamic-settings";

const mapState = ({ dynamicSettings }: IStoreState): IDynamicSettingsContainerState => ({ ...dynamicSettings });

export type IDynamicSettingsContainerProps = IContainerProps<ReturnType<typeof mapState>>;

export const [DynamicSettingsContainer, connectWithDynamicSettings, useDynamicSettings] = generateContainer(mapState);
